import React, { useCallback, useEffect, useRef, useState } from "react";

import { GAME_LAUNCH_BONUS_RECOVERY_EVENT } from "../../lib/bonusRecovery";
import BonusRecoveryModal from "./BonusRecoveryModal";

const GameLaunchBonusRecoveryHost = () => {
  const [request, setRequest] = useState(null);
  const requestRef = useRef(null);

  const settleRequest = useCallback((accepted) => {
    const current = requestRef.current;
    if (!current) return;

    requestRef.current = null;
    current.resolve(Boolean(accepted));
    setRequest(null);
  }, []);

  useEffect(() => {
    const handleBonusRecoveryRequest = (event) => {
      const detail = event?.detail;
      if (typeof detail?.resolve !== "function") return;

      if (requestRef.current) {
        detail.resolve(false);
        return;
      }

      event.preventDefault();
      requestRef.current = detail;
      setRequest(detail);
    };

    window.addEventListener(
      GAME_LAUNCH_BONUS_RECOVERY_EVENT,
      handleBonusRecoveryRequest
    );

    return () => {
      window.removeEventListener(
        GAME_LAUNCH_BONUS_RECOVERY_EVENT,
        handleBonusRecoveryRequest
      );
      const pendingRequest = requestRef.current;
      requestRef.current = null;
      pendingRequest?.resolve(false);
    };
  }, []);

  return (
    <BonusRecoveryModal
      show={Boolean(request)}
      onHide={() => settleRequest(false)}
      onCancel={() => settleRequest(false)}
      onConfirm={() => settleRequest(true)}
      bonusgames={request?.bonusGames}
      actionType={request?.actionType}
    />
  );
};

export default GameLaunchBonusRecoveryHost;
